<template>

    <div class="component-container" v-show="visible">

      <div class="separator">
            <h2>
                <span>{{ user_query.reformulated_query }}</span>
            </h2>
        </div>

        <b-tabs content-class="mt-3" justified pills>
            <ResultsCollection ref="resultsMedline" collection_title="MEDLINE" collection_name="medline"/>
            <ResultsCollection ref="resultsPmc" collection_title="PMC+" collection_name="pmc"/>
            <ResultsCollection ref="resultsPlazi" collection_title="PLAZI" collection_name="plazi"/>
            <ResultsCollection ref="resultsSup" collection_title="Supplementary material" collection_name="suppdata"/>
            <ResultsCollection ref="resultsZen" collection_title="Zenodo" collection_name="zenodo"/>
        </b-tabs>

    </div>

</template>


<script>
import ResultsCollection from '@/components/ResultsCollection.vue'
import { mapState, mapActions } from 'vuex'

    export default {
      name: 'ResultsBox',
      components: {
        ResultsCollection,
      },
      data() {
        return {
          visible: false,
        };
      },
      computed: {
        ...mapState(['user_query']),
      },
      methods:{
        ...mapActions(['updateReformulated']),
        search(){
            this.visible = true
            this.reformulated_query()
            var options = {}
            if (this.user_query.taxon1 != ""){
              options['taxon1'] = this.user_query.taxon1_pt
            }
            if (this.user_query.taxon2 != ""){
              options['taxon2'] = this.user_query.taxon2_pt
            }
            if (this.user_query.interaction != ""){
              options['interaction'] = this.user_query.interaction_pt
            }
            this.$matomo?.trackEvent("Query", this.user_query.taxon1_pt+";"+this.user_query.taxon2_pt+";"+this.user_query.interaction_pt);
            this.$matomo?.trackEvent("QueryNorm", this.user_query.taxon1_id+";"+this.user_query.taxon2_id+";"+this.user_query.interaction_id);
            this.$router.push({ name: 'HomePage', query: options }).catch(()=>{});
            this.$refs.resultsMedline.search()
            this.$refs.resultsPlazi.search()
            this.$refs.resultsPmc.search()
            this.$refs.resultsSup.search()
            this.$refs.resultsZen.search()
            window.document.title = this.user_query.reformulated_query

       },
       reformulated_query() {
            var reformulated = ""
            if (this.user_query.taxon1 != "" && this.user_query.taxon2 != "" && this.user_query.interaction == ""){
              reformulated = "Which evidence does support that "+this.user_query.taxon1+" and "+this.user_query.taxon2+" interact?"
            }
            else if (this.user_query.taxon1 != "" && this.user_query.taxon2 == "" && this.user_query.interaction == ""){
              reformulated =  "Which taxa interact with "+this.user_query.taxon1+"?"
            }
            else if (this.user_query.taxon1 == "" && this.user_query.taxon2 != "" && this.user_query.interaction == ""){
              reformulated =  "Which taxa interact with "+this.user_query.taxon2+"?"
            }
            else if (this.user_query.taxon1 != "" && this.user_query.taxon2 == "" && this.user_query.interaction != ""){
              reformulated =  "Which taxa have a interaction of \""+this.user_query.interaction_pt+"\" with "+this.user_query.taxon1+"?"
            }
            else if (this.user_query.taxon1 == "" && this.user_query.taxon2 != "" && this.user_query.interaction != ""){
              reformulated =  "Which taxa have a interaction of \""+this.user_query.interaction_pt+"\" with "+this.user_query.taxon2+"?"
            }
            else if (this.user_query.taxon1 == "" && this.user_query.taxon2 == "" && this.user_query.interaction != ""){
              reformulated =  "Which taxa have an interaction of \""+this.user_query.interaction_pt+"\"?"
            }
            else if (this.user_query.taxon1 != "" && this.user_query.taxon2 !== "" && this.user_query.interaction != ""){
              reformulated =  "Which evidence does support that "+this.user_query.taxon1+" and "+this.user_query.taxon2+"do have an interaction of \""+this.user_query.interaction_pt+"\"?"
            }
            else if (this.user_query.taxon1 == "" && this.user_query.taxon2 == "" && this.user_query.interaction == ""){
              reformulated =  "Which taxa interact together?"
            }
            this.updateReformulated(reformulated)
        },
      },
    }

</script>


<style scoped lang="scss">

  .export-container {
    margin: 40px 0px;
  }

</style>
